import axios from 'axios';
import { Fragment, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { CommonLoading } from 'react-loadingg';
import AddGroupModal from './AddGroupModal';
import PermissionHeader from './PermissionHeader';
import Permissions from './Permissions';

const Permission = (props) => {
    const [permissionGroups, setPermissionGroups] = useState([]);

    const [isLoading, setIsLoading] = useState(true);
    const [showEdit, setShowEdit] = useState(false);

    const [addGroupModal, setOpenAddGroupModal] = useState(false);
    const handleAddGroupModal = () => setOpenAddGroupModal(!addGroupModal);

    const { REACT_APP_API_BACKEND_URL } = process.env;

    useEffect(() => {
        if (props.loginList) {
            const loginListFromParent = props.loginList;

            const permit = loginListFromParent.some(
                (item) =>
                    item.permissionName.includes('Admin Role') &&
                    item.permissionType.includes('view')
                // ||
                // (item.permissionName.includes("Bulletin Board") && item.permissionType.includes("view"))
            );

            if (!permit) {
                window.stop();
                alert('You have no permissions to access this page.');
                window.location = '/';
            } else {
                setIsLoading(false);
            }

            const editPermit = loginListFromParent.some(
                (item) =>
                    item.permissionName.includes('Admin Role') &&
                    item.permissionType.includes('edit')
                // ||
                // (item.permissionName.includes("Bulletin Board") && item.permissionType.includes("edit"))
            );

            if (editPermit) {
                setShowEdit(true);
            }
        }
    }, [props.loginList]);

    useEffect(() => {
        const getPermissionGroups = async () => {
            const permissionGroupFromServer = await fetchPermissionGroups();
            setPermissionGroups(permissionGroupFromServer);
        };

        getPermissionGroups();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Fetch Permission
    const fetchPermissionGroups = async () => {
        const res = await fetch(
            REACT_APP_API_BACKEND_URL + '/api/getpermission',
            { mode: 'cors' }
        );
        const data = await res.json();

        return data.RoleList;
    };

    // Add Group
    const addGroup = (group) => {
        const url = REACT_APP_API_BACKEND_URL + '/api/submitpermission';
        const groupDetails = {
            groupName: group.groupName,
            userID: group.userID,
            userName: group.userName,
            permission: group.permission,
            createdBy: group.createdBy,
        };

        axios
            .post(url, groupDetails)
            .then(
                (response) =>
                    alert('Group role has been successfully created!'),
                setTimeout(() => {
                    setOpenAddGroupModal(!addGroupModal);
                }, 500),
                setTimeout(() => {
                    window.location.reload();
                }, 1000)
            )
            .catch((err) => console.error(err));
    };

    const PermissionList = () => {
        return (
            <Fragment>
                {permissionGroups.length > 0 ? (
                    <Permissions
                        permissions={permissionGroups}
                        showEdit={showEdit}
                    />
                ) : (
                    <div>No permission group has been created</div>
                )}
            </Fragment>
        );
    };

    return (
        <Fragment>
            {isLoading ? (
                <CommonLoading />
            ) : (
                <div className='main-hero-container'>
                    <div
                        className={`${
                            props.isActive ? 'container is-active' : 'container'
                        }`}
                    >
                        <PermissionHeader />
                        <div className='table-wrapper'>
                            <Button onClick={handleAddGroupModal}>
                                Create New
                            </Button>
                            <AddGroupModal
                                show={addGroupModal}
                                handleClose={handleAddGroupModal}
                                onAdd={addGroup}
                            />
                            <PermissionList />
                        </div>
                    </div>
                </div>
            )}
        </Fragment>
    );
};

export default Permission;
